import * as requestFromServer from "./flashMessageApis";
import Actions from "../../actions";
import { toastService } from "../../../component/common/toast-messages/toast";

// flash message -> get flash message api
export const getFlashMessagesAction = (dataToBeSent, setLoading) => async (dispatch) => {
    setLoading(true);
    const response = await requestFromServer.getFlashMessages(dataToBeSent);
    if (response) {
      dispatch(Actions.createAction(Actions.GET_FLASH_MESSAGES_LIST, {flashMessages:response}))
      setLoading(false);
      return response;
    }
    else {
      setLoading(false)
      return null
    }
};

// flash message -> get flash message api
export const getFlashMessageByIdAction = (dataToBeSent, setLoading) => async (dispatch) => {
    setLoading(true);
    const response = await requestFromServer.getFlashMessageById(dataToBeSent);
    if (response) {
      setLoading(false);
      return response;
    }
    else {
      setLoading(false)
      return null
    }
};

// flash -> delete flash by id api
export const deleteFlashMessageByIdAction = (dataToBeSent) => async (dispatch) => {
  const response = await requestFromServer.deleteFlashMessageById(dataToBeSent);
  if (response) {
    toastService.success(response?.message);
    return response;
  }
};

// flash messages -> create flash api
export const createFlashMessagesAction = (dataToBeSent) => async (dispatch) => {
  const response = await requestFromServer.createFlashMessages(dataToBeSent);
  if (response) {
    toastService.success(response?.message);
    return response;
  }
};

// faqs -> update flash messages api
export const updateFlashMessagesAction = (dataToBeSent) => async (dispatch) => {
  const response = await requestFromServer.updateFlashMessages(dataToBeSent);
  if (response) {
    toastService.success(response?.message);
    return response;
  }
};